import { Maybe } from './globalTypes'

import {
  BentoCardFragment,
  isBentoCardFragment,
} from './BentoCardFragment'

import bentoGridSectionFragmentRawString from '../../fragments/BentoGridSectionFragment.graphql'

export const bentoGridSectionFragmentString = bentoGridSectionFragmentRawString

export type BentoGridSectionFragment = {
  __typename: 'ComponentSectionsBentoGridSection'
  id: string
  gridTitle: Maybe<string>
  gridDescription: Maybe<string>
  cards: Maybe<BentoCardFragment>[]
}

export const isBentoGridSectionFragment = (
  fragment: any,
): fragment is BentoGridSectionFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsBentoGridSection' &&
  typeof fragment.id === 'string' &&
  (fragment.gridTitle === null || typeof fragment.gridTitle === 'string') &&
  (fragment.gridDescription === null ||
    typeof fragment.gridDescription === 'string') &&
  Array.isArray(fragment.cards) &&
  fragment.cards
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (next === null || (isBentoCardFragment(next) as boolean)),
      true,
    )
